import Button from '@wiggui/ds/Button'
import Divider from '@wiggui/ds/Divider'
import Flex from '@wiggui/ds/Flex'
import GoogleIcon from '@wiggui/ds/GoogleIcon'
import IconWiggot from '@wiggui/ds/IconWiggot'
import Overlay from '@wiggui/ds/Overlay'
import Transition from '@wiggui/ds/Transition'
import { useSession } from '@wiggot/auth/hooks/useSession'
import { useAmplitude } from '@wiggot/analytics/src/providers/amplitud-provider/AmplitudeProvider'
import { ProfileButton } from '../profile/ProfileButton'
import { EAmplitudeEvents } from '../amplitudEnums'
import { EAmplitudeEventsMinisitesLanding } from '../../../constants/minisites-events'
import { ROUTES } from '../../../constants'
import { useBodyScrollLock } from '../../../hooks/ds/useBodyScrollLock'

const URL_REDIRECT_LOGIN = ROUTES.AUTH_LOGIN
const URL_REDIRECT_SIGNUP = `${ROUTES.AUTH}/sign-up`

export const HomeSideMenu = ({
  show,
  setShowSideMenu
}: {
  show: boolean
  setShowSideMenu(show: boolean): void
}) => {
  const { trackEvent } = useAmplitude()
  const { token } = useSession()
  const handleGoTo = (route: string) => {
    if (route.includes('crea-tu-sitio')) {
      trackEvent({
        name: EAmplitudeEventsMinisitesLanding.MINISITES_VIEW_SELECTED,
        eventProperties: {
          where: 'menú hamburguesa',
          isLogin: Boolean(token)
        }
      })
    }
    if (route.includes('plans')) {
      trackEvent({
        name: EAmplitudeEvents.PLANS_ACTION,
        eventProperties: {
          where: 'side_menu',
          isLogin: Boolean(token)
        }
      })
    }
    window.location.replace(`${window.location.origin}${route}`)
    setShowSideMenu(false)
  }

  useBodyScrollLock(show)
  const handleLogin = () => {
    trackEvent({
      name: EAmplitudeEvents.LANDING_BEGIN
    })
  }
  const handleEvent = () => {
    trackEvent({
      name: EAmplitudeEvents.LANDING_LOGIN,
      eventProperties: {
        where: 'navbar'
      }
    })
  }

  return (
    <Overlay onClose={() => setShowSideMenu(false)} show={show}>
      <Transition
        duration={150}
        className=" fixed right-0 w-[85%] md:w-screen h-screen bg-white text-primary z-[3]"
        show={show}
      >
        <Flex items="between" dir="col">
          <div className="flex items-center justify-between py-2 px-3 border-b border-surface-strokes">
            <button type="button" onClick={() => handleGoTo('/')}>
              <IconWiggot width="36px" height="36px" variant="black" />
            </button>
            <button
              type="button"
              onClick={() => setShowSideMenu(false)}
              className="flex justify-center items-center w-12 h-12 p-3"
            >
              <GoogleIcon name="close" />
            </button>
          </div>

          <Flex dir="col">
            {token ? (
              <div className="p-3">
                <ProfileButton variant="white" />
              </div>
            ) : (
              <>
                {' '}
                <p className="text-xl font-semibold p-3">Bienvenido a Wiggot</p>
                <div className="w-full p-3 flex gap-1 items-center justify-between">
                  <a
                    onClick={handleEvent}
                    className="text-black underline text-sm font-medium w-fit"
                    href={URL_REDIRECT_LOGIN}
                  >
                    Iniciar sesión
                  </a>
                  <a onClick={handleLogin} href={URL_REDIRECT_SIGNUP}>
                    <Button
                      className="w-[209px] !bg-black"
                      size="medium"
                      variant="cancel"
                    >
                      Inicia tu prueba gratuita
                    </Button>
                  </a>
                </div>
              </>
            )}

            {!token && <Divider height={8} />}
            <p className="text-xl font-semibold p-3">Menú principal</p>
            <Flex gap={4} dir="col" className="px-1">
              <Flex
                onClick={() => handleGoTo('/')}
                wFull
                as="button"
                gap={1}
                items="center"
              >
                <div className="w-12 h-12 p-3">
                  {' '}
                  <GoogleIcon name="home" />
                </div>
                <p className="text-base text-primary">Inicio</p>
              </Flex>
              <Flex
                onClick={() => handleGoTo('/crea-tu-sitio')}
                wFull
                as="button"
                gap={1}
                items="center"
              >
                <div className="w-12 h-12 p-3">
                  {' '}
                  <GoogleIcon name="language" />
                </div>
                <p className="text-base text-primary">Tu sitio web</p>
              </Flex>
              <Flex
                onClick={() => handleGoTo('/plans')}
                wFull
                as="button"
                gap={1}
                items="center"
              >
                <div className="w-12 h-12 p-3">
                  {' '}
                  <GoogleIcon name="local_offer" />
                </div>
                <p className="text-base text-primary">Planes</p>
              </Flex>
            </Flex>
          </Flex>
        </Flex>
      </Transition>
    </Overlay>
  )
}

export default HomeSideMenu
